import React from 'react'

import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';

import { Loading } from '../../components/shared'
import { commifyNumber } from '../../utils/utilities'
import featureFlags from '../../utils/featureFlags'
import isUnderwriter from '../../utils/is-underwriter'

function Limits({ onChange, defaultValue, name, type, values, user = {} }) {

  let limits = [];
  if (type === 'oi') {
    (!isUnderwriter(user)) ?
    limits = [{"text": "Select", "value": ""}, { "value": "1000000", "text": "1,000,000" }, { "value": "2000000", "text": "2,000,000" }, { "value": "3000000", "text": "3,000,000" }, { "value": "4000000", "text": "4,000,000" }, { "value": "5000000", "text": "5,000,000" }, { "value": "6000000", "text": "6,000,000" }, { "value": "7000000", "text": "7,000,000" }, { "value": "8000000", "text": "8,000,000" }, { "value": "9000000", "text": "9,000,000" }, { "value": "10000000", "text": "10,000,000" }] :
    limits = [{ "value": "1000000", "text": "1,000,000" }, { "value": "2000000", "text": "2,000,000" }, { "value": "3000000", "text": "3,000,000" }, { "value": "4000000", "text": "4,000,000" }, { "value": "5000000", "text": "5,000,000" }, { "value": "6000000", "text": "6,000,000" }, { "value": "7000000", "text": "7,000,000" }, { "value": "8000000", "text": "8,000,000" }, { "value": "9000000", "text": "9,000,000" }, { "value": "10000000", "text": "10,000,000" },
    { "value": "11000000", "text": "11,000,000" }, { "value": "12000000", "text": "12,000,000" }, { "value": "13000000", "text": "13,000,000" }, { "value": "14000000", "text": "14,000,000" }, { "value": "15000000", "text": "15,000,000" }, { "value": "16000000", "text": "16,000,000" }, { "value": "17000000", "text": "17,000,000" }, { "value": "18000000", "text": "18,000,000" }, { "value": "19000000", "text": "19,000,000" }, { "value": "20000000", "text": "20,000,000" }] 
  } else if (type === 'ocp') {
    limits = [{"text": "Select", "value": ""}, { "text": "1m/2m", "value": "12" }, { "text": "2m/2m", "value": "22" }, { "text": "2m/4m", "value": "24" }, { "text": "3m/3m", "value": "33" }, { "text": "4m/4m", "value": "44" }, { "text": "5m/5m", "value": "55" }, { "text": "6m/6m", "value": "66" }]
  }
  const limValues = limits.map(l => l.value);
  
  return (
    <Row>
      <Col xs={8} md={6} className={name}>
        <h4 className="quoteTitle">Limits</h4>
        <FormGroup controlId="formControlsSelect">
          <FormControl
            onChange={onChange}
            name={name}
            defaultValue={defaultValue}
            componentClass="select">
            {limits.map(({ value, text }, i) => (
              <option key={i} value={value} hidden ={(type !== 'oi' && value === "") || (value === "" && limValues.includes(defaultValue))}>
                {text}
              </option>
            ))}
          </FormControl>
        </FormGroup>
      </Col>
    </Row>
  )
}

const mapStateToProps = store => ({
  user: store.user
})

export default connect(mapStateToProps)(Limits)